// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen`.

import Ajv from "ajv";
import addFormats from "ajv-formats";
import call from "../../sdk-helpers/call";
import { logError } from "../../sdk-helpers/shouldLog";

export type typeBlockAddBody = {
  blockedAccountId: string;
};

export type typeBlockAddOutput200 = {
  error?: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data?: null | { isBlocked: boolean };
};

export type typeBlockAddOutput400 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeBlockAddOutput401 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeBlockAddOutput500 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export const schemaBlockAddBody = {
  type: "object",
  properties: {
    blockedAccountId: { type: "string", maxLength: 3000, minLength: 1 },
  },
  required: ["blockedAccountId"],
} as const;

export type SdkOptions = {
  headers?: Record<string, string>;
  apiHost?: string;
  prefix?: string;
};

let compiledValidator: ReturnType<Ajv["compile"]> | null = null;

export default function createBlockAdd(options: SdkOptions) {
  if (!compiledValidator) {
    const ajv = new Ajv({ strict: false });
    addFormats(ajv);
    compiledValidator = ajv.compile(schemaBlockAddBody);
  }

  return async function postBlockAdd(
    payload: typeBlockAddBody,
  ): Promise<typeBlockAddOutput200 | typeBlockAddOutput400> {
    const isValid = compiledValidator!(payload);
    if (!isValid) {
      logError(
        `Payload validation inside SDK method "postBlockAdd" failed before calling the network. #880050099965`,
        compiledValidator!.errors,
      );
      return {
        error: {
          code: "VALIDATION_ERROR",
          message: "Request payload failed schema validation.",
          details: { errors: compiledValidator!.errors, ref: "#880050099965" },
        },
        data: null,
      } as typeBlockAddOutput400;
    }

    const prefix = options?.prefix ?? "";
    return (await call({
      payload,
      endpoint: `${prefix}/block/add`,
      httpMethod: "POST",
      options,
    })) as typeBlockAddOutput200 | typeBlockAddOutput400;
  };
}
